import { CorporateOverviewGeneral } from '../../../../hoc/corporate/types';
import { GeneralCompanyAddressesTypes } from '../types';
import OverviewGeneralRow from './general-row';

const AddressesContent = ({
  control,
  edit,
  countries,
  errors,
  title,
  name,
}: GeneralCompanyAddressesTypes) => (
  <>
    <OverviewGeneralRow
      title={`${title} country`}
      control={control}
      edit={edit}
      name={`${name}CountryId` as keyof CorporateOverviewGeneral}
      type="autocomplete"
      list={countries}
      error={
        errors?.[`${name}CountryId` as keyof CorporateOverviewGeneral]?.message
      }
    />
    <OverviewGeneralRow
      title={`${title} city`}
      control={control}
      edit={edit}
      name={`${name}City` as keyof CorporateOverviewGeneral}
      type="text"
      error={errors?.[`${name}City` as keyof CorporateOverviewGeneral]?.message}
    />
    <OverviewGeneralRow
      title={`${title} postal code`}
      control={control}
      edit={edit}
      name={`${name}PostalCode` as keyof CorporateOverviewGeneral}
      type="text"
      error={
        errors?.[`${name}PostalCode` as keyof CorporateOverviewGeneral]?.message
      }
    />
    <OverviewGeneralRow
      title={`${title} address 1`}
      control={control}
      edit={edit}
      name={`${name}Address1` as keyof CorporateOverviewGeneral}
      type="text"
      error={
        errors?.[`${name}Address1` as keyof CorporateOverviewGeneral]?.message
      }
    />
    <OverviewGeneralRow
      title={`${title} address 2`}
      control={control}
      edit={edit}
      name={`${name}Address2` as keyof CorporateOverviewGeneral}
      error={
        errors?.[`${name}Address2` as keyof CorporateOverviewGeneral]?.message
      }
      type="text"
    />
  </>
);

export default AddressesContent;
